const getters = {
    fitoProducts: state => state.fitoProducts,
    fitoProductsLight: state => state.fitoProductsLight,
  }
  
  export default getters;
  